module.exports = __webpack_public_path__ + "img/chenggong.7bfd4a56.png";